import { pseudoClassValues } from './utils/values';

const plugin = require('tailwindcss/plugin');

export default plugin(({ matchVariant }) => {
  matchVariant(
    'previous-sibling',
    (value, { modifier }) =>
      `.peer${modifier ? `\\/${modifier}` : ''}${value.length ? `:${value}` : ''} + &`,
    {
      values: {
        DEFAULT: '',
        ...pseudoClassValues,
      },
    },
  );
});
